var _excluded = ["disabled", "error", "full", "helper", "label", "maxLength", "className", "style", "value", "onChange"];

var _templateObject, _templateObject2, _templateObject3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { string, bool, number, func, shape } from 'prop-types';
import FieldSet from '../../Input/web/Fieldset';
import Field from '../../Input/web/Field';
import Label from '../../Input/web/Label';
import Legend from '../../Input/web/Legend';
import Helper from '../../Input/web/Helper';
var Root = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n\n  cursor: text;\n\n  ", "\n"])), function (_ref) {
  var full = _ref.full;
  return "\n    width: " + (full ? '100%' : 'auto') + ";\n  ";
});
var StyledFieldSet = styled(FieldSet)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  height: 88px;\n  box-sizing: border-box;\n"])));
var StyledField = styled(Field)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  resize: none;\n  height: 100%;\n"])));
/**
 * TextArea is a type of text field which has a larger initiation size to
 * encourage a bigger user input. This component has a fixed height and the text
 * lines are increased when the input reaches the limit of lines established for
 * the field. This action creates a vertical scroll inside the component.
 */

var TextArea = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var disabled = _ref2.disabled,
      error = _ref2.error,
      full = _ref2.full,
      helper = _ref2.helper,
      label = _ref2.label,
      maxLength = _ref2.maxLength,
      className = _ref2.className,
      style = _ref2.style,
      value = _ref2.value,
      _onChange = _ref2.onChange,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  var _useState = useState(value),
      textAreaValue = _useState[0],
      setTextAreaValue = _useState[1];

  var _useState2 = useState(Boolean(value)),
      typed = _useState2[0],
      setTyped = _useState2[1];

  var textAreaRef = ref || useRef(null);
  useEffect(function () {
    setTextAreaValue(value);
    setTyped(Boolean(value));
  }, [value]);
  return /*#__PURE__*/React.createElement(Root, {
    className: className,
    full: full,
    style: style,
    onClick: function onClick() {
      return textAreaRef.current.focus();
    }
  }, /*#__PURE__*/React.createElement(StyledFieldSet, {
    error: error,
    disabled: disabled,
    full: full,
    label: label
  }, /*#__PURE__*/React.createElement(StyledField, _extends({}, props, {
    disabled: disabled,
    full: full,
    label: label,
    as: "textarea",
    ref: textAreaRef,
    cleanable: false,
    maxLength: maxLength,
    typed: typed,
    error: error,
    value: textAreaValue,
    onChange: function onChange(e) {
      setTextAreaValue(e.target.value);
      setTyped(Boolean(e.target.value));

      _onChange(e);
    }
  })), /*#__PURE__*/React.createElement(Label, _extends({
    error: error,
    disabled: disabled
  }, props), label), label && /*#__PURE__*/React.createElement(Legend, null, label)), /*#__PURE__*/React.createElement(Helper, {
    disabled: disabled,
    error: error,
    helper: helper,
    maxLength: maxLength,
    length: textAreaValue.length
  }));
});
TextArea.propTypes = {
  className: string,
  disabled: bool,

  /** A error text to be displayed below field */
  error: string,
  full: bool,

  /** A helper text to be displayed below field */
  helper: string,
  label: string,

  /** maximum length (number of characters) of value */
  maxLength: number,
  placeholder: string,
  readOnly: bool,
  style: shape({}),
  value: string,
  onChange: func
};
TextArea.defaultProps = {
  className: undefined,
  disabled: false,
  error: undefined,
  full: false,
  helper: undefined,
  label: '',
  maxLength: undefined,
  placeholder: undefined,
  readOnly: false,
  style: undefined,
  value: '',
  onChange: function onChange() {}
};
export default TextArea;